import React, { useRef, useState } from 'react'
import { findOnArray } from 'reacticoon/utils/array'
import useCommand from 'components/useCommand'
import useStorageState from 'reacticoon/view/hook/useStorageState'
import useMountEffect from 'reacticoon/view/hook/useMountEffect'
import useAddFlashMessage from 'reacticoon-plugin-flash-messages/useAddFlashMessage'
import SettingsContext from '../modules/settings/context'

const MajView = ({ children }) => {
  const [settings, setSettings] = useState(null)
  const [version, setVersion] = useStorageState('APP_VERSION', null)
  const [activeTheme, setActiveTheme] = useStorageState('ACTIVE_THEME', 'default')
  const [hasBeenUpdated, setHasBeenUpdate] = useStorageState('APP_VERSION_UPDATED', true)
  const { addSuccessFlashMessage } = useAddFlashMessage()
  const reloadTimeoutRef = useRef(null)
  const isMountedRef = useRef(true)

  useMountEffect(() => {
    // Vérifier directement dans localStorage pour éviter les affichages multiples
    const storedValue = localStorage.getItem('APP_VERSION_UPDATED')
    const shouldShowMessage = storedValue === 'true' || storedValue === true
    
    if (shouldShowMessage) {
      // Mettre à jour le storage immédiatement pour éviter les doublons
      localStorage.setItem('APP_VERSION_UPDATED', 'false')
      setHasBeenUpdate(false)
      
      addSuccessFlashMessage({
        text: `TASEv3 a été mise à jour`,
        duration: 5000
      })
    }
    
    // Cleanup du timeout et marquer comme démonté
    return () => {
      isMountedRef.current = false
      if (reloadTimeoutRef.current) {
        clearTimeout(reloadTimeoutRef.current)
      }
    }
  })

  useCommand({
    command: 'GET_SETTINGS',
    payload: {},
    displayError: false,
    manualPending: true,
    keepDataOnRequest: true,
    onSuccess: (response) => {
      if (!isMountedRef.current) return // Ne pas mettre à jour le state si démonté
      
      setSettings(response) // TRICK: FUCK THIS, infinite loop if we use const { data: settings } = useCommand
      
      const responseVersion = findOnArray(response, setting => setting.name === 'front_version')
      // TODO: do not reload if version is nil, to avoid reloading first time we open tase.
      if (responseVersion && version !== responseVersion.value) {
        setVersion(responseVersion.value)
        if (isMountedRef.current) {
          reloadTimeoutRef.current = setTimeout(() => {
            setHasBeenUpdate(true)
            window.location.reload(true)
          }, 400)
        }
      }

      // Check for activeTheme changes (for Christmas, Easter, etc.)
      const responseActiveTheme = findOnArray(response, setting => setting.name === 'activeTheme')
      if (responseActiveTheme && activeTheme !== responseActiveTheme.value) {
        setActiveTheme(responseActiveTheme.value)
        
        // If theme changed from server, reset user preferences to default enabled state
        if (responseActiveTheme.value !== 'default') {
          localStorage.setItem('CHRISTMAS_SETTINGS', JSON.stringify({
            snowfall: true,
            trees: true,
            santa: true,
          }))
        }
      }
    }
  })

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  )
}

export default MajView